import React, { useState, useEffect } from 'react';

const slogans = [
  "Nurturing Excellence, Shaping Futures.",
  "Where Little Minds Begin Big Journeys.",
  "Rooted in Values, Growing in Knowledge.",
  "Empowering Lifelong Learners.",
  "Light & Love."
];

function Typewriter() {
  const [text, setText] = useState('');
  const [index, setIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const current = slogans[index];
    const timeout = setTimeout(() => {
      if (!isDeleting && charIndex === current.length) {
        setTimeout(() => setIsDeleting(true), 2000);
      } else if (isDeleting && charIndex === 0) {
        setIsDeleting(false);
        setIndex((index + 1) % slogans.length);
      } else {
        setText(current.substring(0, charIndex + (isDeleting ? -1 : 1)));
        setCharIndex(charIndex + (isDeleting ? -1 : 1));
      }
    }, isDeleting ? 50 : 100);

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, index]);

  return <h2 style={{fontSize: '2.5rem', color: '#93c5fd', fontWeight: 700, minHeight: '80px', fontStyle: 'italic', textShadow: '3px 3px 6px rgba(0,0,0,0.8)'}}>{text}</h2>;
}

export default Typewriter;
